export default "__VITE_ASSET__957f600a__"